//system
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { HttpService, HttpServiceConfig } from './common/http.service';

//services
import { LogService } from './common/log.service';

//models
import { AppConfigurations, ClassesTab, CurrencyMeta } from 'src/app/models/meta';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  cachedClassTab$!: Observable<ClassesTab> | null;
  cachedAppConfiguration$!: Promise<AppConfigurations>;
  private cachedCurrencyMetaByMember = new Map<number, Promise<CurrencyMeta>>();
  
  constructor(private logService: LogService
    , private httpService: HttpService
    , private _environmentService: EnvironmentService
  ) { 
    this.cachedClassTab$ = null;
    const config: HttpServiceConfig = {
      baseUrl: `${this._environmentService.getFacilityConfig().facilityUrl}api/v${this._environmentService.getFacilityConfig().facilityApiVersion}`
    };
    this.httpService.configure(config);
  }

  // to get cached last request data pass false
  getClassesMeta(force: boolean = true, locationId: number = 0): Observable<ClassesTab> {
    if (!this.cachedClassTab$ || force) {
      this.cachedClassTab$ = this.httpService.get<ClassesTab>(`Meta/ClassesTab/Public/${locationId}`).pipe(
        shareReplay({ bufferSize: 1, refCount: true })
      );
    }
    return this.cachedClassTab$;
  }

  getAppConfigurations(force: boolean = true, locationId: number = 0): Promise<AppConfigurations> {
    if (!this.cachedAppConfiguration$ || force) {
      this.cachedAppConfiguration$ = this.httpService.getPromise<AppConfigurations>(`Meta/AppConfigurations/Public/${locationId}`);
    }
    return this.cachedAppConfiguration$;
  }

  getCurrencyMetaByMember(memberId: number, force = false): Promise<CurrencyMeta> {
    if (!force && this.cachedCurrencyMetaByMember.has(memberId)) {
      return this.cachedCurrencyMetaByMember.get(memberId)!;
    }
    const request = this.httpService.getPromise<CurrencyMeta>(`Currency/Meta/ByMember/${memberId}`);
    this.cachedCurrencyMetaByMember.set(memberId, request);
    return request;
  }

  getCurrencyMetaByLocation(locationId:number): Promise<CurrencyMeta> {
    return this.httpService.getPromise<CurrencyMeta>(`Currency/Meta/ByLocation/${locationId}`);
  }
}